// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* .info-pill {\n  background: #fff;\n  border: 1px solid #e3e6ea;\n  border-radius: 50px;\n  padding: 8px 14px;\n  display: inline-block;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.costing-card:hover {\n  background: #f9fafc;\n  transition: 0.2s ease-in-out;\n}\n\n\n.info-label {\n  display: inline-block;\n  width: 77px; /* adjust spacing as needed */\n  /* font-weight: bold;\n}\n.info-label-val{\n  display: inline-block;\n  width: 157px;\n} */", ""]);
// Exports
module.exports = exports;
